/* eslint-disable */
// MU-04-10-20 Removing the event binding functionality for now, we need to handle events using events logic

export default {
  layout_elements: {
    'lg': {
      'p_1': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_lg.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "control", event_actions: 1}
          ]
        },
        '12-lg-1-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Shutdown'
          }
        },
        '12-lg-1-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Privacy'
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-1-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Cam Privacy'
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-1-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64"
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-1-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-1-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '60px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
            'P_imgWidth': '72px',
            'P_imgHeight': '43px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-1-49A5137K-2': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 7,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Solstice Pod',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/solstice_pod_2.png',
            'P_imgWidth': '50%',
            'P_imgHeight': '',
            'P_flexDirection': '',
          },
          logic: {
            '7': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-1-49A5137K-3': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 8,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Room PC',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/room_pc_alt.png',
            'P_imgWidth': '50%',
            'P_imgHeight': '',
            'P_flexDirection': '',
          },
          logic: {
            '8': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-1-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-lg-1-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-1-49A5137J-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 6,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Blank',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/blank-source.png',
            'P_imgWidth': '50%',
            'P_imgHeight': '',
            'P_flexDirection': '',
          },
          logic: {
            '6': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-1-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a source from the list below.',
            'P_fontSize': '1.4rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-lg-1-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-1-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        }
      },
      'p_2': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_lg.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "camera", event_actions: 1}
          ]
        },
        '12-lg-2-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Shutdown'
          }
        },
        '12-lg-2-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Privacy'
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Cam Privacy'
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-2-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-2-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '60px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
			      'P_imgWidth': '72px',
            'P_imgHeight': '43px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-2-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-lg-2-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }        },
        '12-lg-2-49A5137J-1': {
            component_id: 'GCameraControl',
            available_props: {
              'P_buttonHomeId': 51,
              'P_buttonHomeMakeSingleEvent': 'single',
              'P_buttonUpId': 52,
              'P_buttonUpMakeSingleEvent': 'multiple',
              'P_buttonRightId': 53,
              'P_buttonRightMakeSingleEvent': 'multiple',
              'P_buttonDownId': 54,
              'P_buttonDownMakeSingleEvent': 'multiple',
              'P_buttonLeftId': 55,
              'P_buttonLeftMakeSingleEvent': 'multiple',
            },
            logic: {}
        },
        '12-lg-2-CDAATOVJR-1': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 56,
            'P_makeSingleEvent': 'multiple',
            'P_disabled': 0,
            'P_buttonText': '- Zoom out',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_iconName': 'search',
            'P_iconSize': '1rem',
            'P_iconColor': 'white',
            'P_flexDirection': ''
          },
        },
        '12-lg-2-CDAATOVJR-2': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 57,
            'P_makeSingleEvent': 'multiple',
            'P_disabled': 0,
            'P_buttonText': '+ Zoom In',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_iconName': 'search',
            'P_iconSize': '1rem',
            'P_iconColor': 'white',
            'P_flexDirection': ''
          },
        },
        '12-lg-2-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 61,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Camera 1',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '61': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 62,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Camera 2',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '62': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-HAN66INF-3': {
          component_id: 'GButton',
          available_props:{
            'P_buttonId': 63,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Camera 3',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '63': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-HAN66INF-4': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 64,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 1',
            'P_fontColor': 'white',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '64': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-HAN66INF-5': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 65,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 2',
            'P_fontColor': 'white',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '65': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-HAN66INF-6': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 66,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 3',
            'P_fontColor': 'white',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '66': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-HAN66INF-7': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 67,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 4',
            'P_fontColor': 'white',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '67': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-2-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
      },
      'p_3': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_intro_lg.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '10',
          'P_isPageClickable': '1'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "intro", event_actions: 1}
          ]
        },
        '12-lg-3-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/NU_GUI/wordmark_northeastern.png',
          },
        },
        '12-lg-3-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Touch Screen to Begin',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
        },
        '12-lg-3-49A5137P': {
          component_id: 'GText',
          available_props: {
            'P_text': '',
            'P_fontSize': '3rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
          logic: {
            '80': [
              {event_type: 3, event_actions: 4, eval_text: ' '}
            ]
          }
        },
      },
      'p_4': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_lg.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "autoswitch-off", event_actions: 1}
          ]
        },
        '12-lg-4-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Shutdown'
          }
        },
        '12-lg-4-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Privacy'
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-4-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64"
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-4-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-4-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '60px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
            'P_imgWidth': '72px',
            'P_imgHeight': '43px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-4-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-lg-4-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-4-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-4-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-4-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a camera preset from the list below.',
            'P_fontSize': '1.6rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-lg-4-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 71,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Presenter',
            'P_fontColor': 'white',
            'P_fontSize': '2rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '71': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-4-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 72,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Audience Cameras',
            'P_fontColor': 'white',
            'P_fontSize': '2rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '72': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-4-HAN66INF-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 73,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'All Room Cameras',
            'P_fontColor': 'white',
            'P_fontSize': '2rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '73': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-4-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Cam Privacy'
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
      },
      'p_5': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_lg.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "autoswitch-on", event_actions: 1}
          ]
        },
        '12-lg-5-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Shutdown'
          }
        },
        '12-lg-5-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Privacy'
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-lg-5-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64"
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-5-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-lg-5-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '60px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
            'P_imgWidth': '72px',
            'P_imgHeight': '43px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-5-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-lg-5-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-5-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-5-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '1.4rem',
            'P_fontWeight': '',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-5-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a camera layout from the list below.',
            'P_fontSize': '1.6rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-lg-5-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Displays an Active Speaker in Class',
            'P_fontSize': '1.6rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-lg-5-49A5137B-3': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Displays Active Speakers in Class',
            'P_fontSize': '1.6rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-lg-5-49A5137B-4': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Gives Room Overview 3 Combined View',
            'P_fontSize': '1.6rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-lg-5-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 41,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Active Speaker Single View',
            'P_fontColor': 'white',
            'P_fontSize': '1.8rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '41': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-lg-5-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 42,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Split View - Lecturer and Audience',
            'P_fontColor': 'white',
            'P_fontSize': '1.8rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          }
        },
        '12-lg-5-HAN66INF-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 43,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'View Room 3 Camera Room',
            'P_fontColor': 'white',
            'P_fontSize': '1.8rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          }
        },
        '12-lg-5-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Cam Privacy'
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        }
      }
    },
    'md': {
      'p_1': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_md.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "control", event_actions: 1}
          ]
        },
        '12-md-1-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-md-1-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-1-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-1-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-1-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-1-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-1-49A5137K-2': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 7,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Solstice Pod',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/solstice_pod_2.png',
            'P_imgWidth': '50%',
            'P_imgHeight': '',
            'P_flexDirection': '',
          },
          logic: {
            '7': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-1-49A5137K-3': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 8,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Room PC',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/room_pc_alt.png',
            'P_imgWidth': '50%',
            'P_imgHeight': '',
            'P_flexDirection': '',
          },
          logic: {
            '8': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-1-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '0.9rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-md-1-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-1-49A5137J-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 6,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Blank',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/blank-source.png',
            'P_imgWidth': '50%',
            'P_imgHeight': '',
            'P_flexDirection': '',
          },
          logic: {
            '6': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-1-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a source from the list below.',
            'P_fontSize': '1rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-md-1-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-1-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        }
      },
      'p_2': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_md.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "camera", event_actions: 1}
          ]
        },
        '12-md-2-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-md-2-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-2-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-2-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-2-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '0.9rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-md-2-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-2-49A5137J-1': {
            component_id: 'GCameraControl',
            available_props: {
              'P_buttonHomeId': 51,
              'P_buttonHomeMakeSingleEvent': 'single',
              'P_buttonUpId': 52,
              'P_buttonUpMakeSingleEvent': 'multiple',
              'P_buttonRightId': 53,
              'P_buttonRightMakeSingleEvent': 'multiple',
              'P_buttonDownId': 54,
              'P_buttonDownMakeSingleEvent': 'multiple',
              'P_buttonLeftId': 55,
              'P_buttonLeftMakeSingleEvent': 'multiple',
            },
            logic: {}
        },
        '12-md-2-CDAATOVJR-1': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 56,
            'P_makeSingleEvent': 'multiple',
            'P_disabled': 0,
            'P_buttonText': '- Zoom out',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_iconName': 'search',
            'P_iconSize': '1rem',
            'P_iconColor': 'white',
            'P_flexDirection': ''
          },
        },
        '12-md-2-CDAATOVJR-2': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 57,
            'P_makeSingleEvent': 'multiple',
            'P_disabled': 0,
            'P_buttonText': '+ Zoom In',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_iconName': 'search',
            'P_iconSize': '1rem',
            'P_iconColor': 'white',
            'P_flexDirection': ''
          },
        },
        '12-md-2-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 61,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Camera 1',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '61': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 62,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Camera 2',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '62': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-HAN66INF-3': {
          component_id: 'GButton',
          available_props:{
            'P_buttonId': 63,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Camera 3',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '63': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-HAN66INF-4': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 64,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 1',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '64': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-HAN66INF-5': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 65,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 2',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '65': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-HAN66INF-6': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 66,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 3',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '66': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-2-HAN66INF-7': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 67,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 4',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '67': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
         '12-md-2-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-2-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        }
      },
      'p_3': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_intro_md.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '10',
          'P_isPageClickable': '1'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "intro", event_actions: 1}
          ]
        },
        '12-md-3-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/NU_GUI/wordmark_northeastern.png',
          },
        },
        '12-md-3-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Touch Screen to Begin',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
        },
        '12-md-3-49A5137P-3': {
          component_id: 'GText',
          available_props: {
            'P_text': '',
            'P_fontSize': '3rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
          logic: {
            '80': [
              {event_type: 3, event_actions: 4, eval_text: ' '}
            ]
          }
        },
      },
      'p_4': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_md.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "autoswitch-off", event_actions: 1}
          ]
        },
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "control", event_actions: 1}
          ]
        },
        '12-md-4-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-md-4-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-4-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-4-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-4-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-4-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '0.9rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-md-4-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-4-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-4-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-4-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a camera preset from the list below.',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-md-4-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 71,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Presenter',
            'P_fontColor': 'white',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '71': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-4-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 72,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Audience Cameras',
            'P_fontColor': 'white',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '72': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-4-HAN66INF-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 73,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'All Room Cameras',
            'P_fontColor': 'white',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '73': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-4-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
      },
      'p_5': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_md.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "autoswitch-on", event_actions: 1}
          ]
        },
        '12-md-5-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-md-5-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-md-5-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-5-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-md-5-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'AV Routing',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-5-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '0.9rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-md-5-49A5137A-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Manual Control',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-5-49A5137A-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch ON',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-5-49A5137A-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'AutoSwitch OFF',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-5-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a camera layout from the list below.',
            'P_fontSize': '1.5rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-md-5-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Displays an Active Speaker in Class',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-md-5-49A5137B-3': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Displays Active Speakers in Class',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-md-5-49A5137B-4': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Gives Room Overview 3 Combined View',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          }
        },
        '12-md-5-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 41,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Active Speaker Single View',
            'P_fontColor': 'white',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '41': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-md-5-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 42,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Split View - Lecturer and Audience',
            'P_fontColor': 'white',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          }
        },
        '12-md-5-HAN66INF-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 43,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'View Room 3 Camera View',
            'P_fontColor': 'white',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          }
        },
        '12-md-5-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        }
      }
    },
    'sm': {
      'p_1': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_sm.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "control", event_actions: 1}
          ]
        },
        '12-sm-1-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-sm-1-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-1-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-1-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-1-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-1-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'column',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-1-49A5137K-2': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 7,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Solstice Pod',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/solstice_pod_2.png',
            'P_imgWidth': '20%',
            'P_imgHeight': '',
            'P_flexDirection': 'row',
          },
          logic: {
            '7': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-1-49A5137K-3': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 8,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Room PC',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/room_pc_alt.png',
            'P_imgWidth': '20%',
            'P_imgHeight': '',
            'P_flexDirection': 'row',
          },
          logic: {
            '8': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-1-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-sm-1-49A5137J-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 6,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'Blank',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': '#c8c8c8',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '1.2rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/blank-source.png',
            'P_imgWidth': '20%',
            'P_imgHeight': '',
            'P_flexDirection': 'row',
          },
          logic: {
            '6': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-1-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a source from the list below.',
            'P_fontSize': '1rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
        },
        '12-sm-1-49A5137J-2': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '',
            'P_fontWeight': '',
            'P_iconName': 'camera',
            'P_iconSize': '1.6rem',
            'P_iconColor': 'white',
            'P_flexDirection': '',
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-1-49A5137K-4': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'OFF',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-1-49A5137K-5': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'ON',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        }
      },
      'p_2': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_sm.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "camera", event_actions: 1}
          ]
        },
        '12-sm-2-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-sm-2-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-2-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-2-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'column',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-2-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-sm-2-49A5137J-6': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '',
            'P_fontWeight': '',
            'P_iconName': 'camera',
            'P_iconSize': '1.6rem',
            'P_iconColor': 'white',
            'P_flexDirection': '',
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-2-49A5137J-1': {
            component_id: 'GCameraControl',
            available_props: {
              'P_buttonHomeId': 51,
              'P_buttonHomeMakeSingleEvent': 'single',
              'P_buttonUpId': 52,
              'P_buttonUpMakeSingleEvent': 'multiple',
              'P_buttonRightId': 53,
              'P_buttonRightMakeSingleEvent': 'multiple',
              'P_buttonDownId': 54,
              'P_buttonDownMakeSingleEvent': 'multiple',
              'P_buttonLeftId': 55,
              'P_buttonLeftMakeSingleEvent': 'multiple',
            },
            logic: {}
        },
        '12-sm-2-CDAATOVJR-1': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 56,
            'P_makeSingleEvent': 'multiple',
            'P_disabled': 0,
            'P_buttonText': '- Zoom out',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '',
            'P_fontWeight': 'bold',
            'P_iconName': 'search',
            'P_iconSize': '1rem',
            'P_iconColor': 'white',
            'P_flexDirection': ''
          },
        },
        '12-sm-2-CDAATOVJR-2': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 57,
            'P_makeSingleEvent': 'multiple',
            'P_disabled': 0,
            'P_buttonText': '+ Zoom In',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '',
            'P_fontWeight': 'bold',
            'P_iconName': 'search',
            'P_iconSize': '1rem',
            'P_iconColor': 'white',
            'P_flexDirection': ''
          },
        },
        '12-sm-2-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 61,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Cam 1',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '61': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 62,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Cam 2',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '62': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-HAN66INF-3': {
          component_id: 'GButton',
          available_props:{
            'P_buttonId': 63,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Cam 3',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '63': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-HAN66INF-4': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 64,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 1',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '64': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-HAN66INF-5': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 65,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 2',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '65': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-HAN66INF-6': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 66,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 3',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '66': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-HAN66INF-7': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 67,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Preset 4',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '67': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-2-49A5137K-2': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'OFF',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-2-49A5137K-3': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'ON',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        }
      },
      'p_3': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_intro_sm.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '10',
          'P_isPageClickable': '1'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "intro", event_actions: 1}
          ]
        },
        '12-sm-3-49A5137D-1': {
          component_id: 'GImage',
          available_props: {
            'P_imageSrc': '/dynamic/images/b1/NU_GUI/wordmark_northeastern.png',
          },
        },
        '12-sm-3-49A5137B-2': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Touch Screen to Begin',
            'P_fontSize': '1rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
        },
        '12-sm-3-49A5137P-3': {
          component_id: 'GText',
          available_props: {
            'P_text': '',
            'P_fontSize': '2rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
          logic: {
            '80': [
              {event_type: 3, event_actions: 4, eval_text: ' '}
            ]
          }
        }
      },
      'p_4': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_sm.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "autoswitch-off", event_actions: 1}
          ]
        },
        '12-sm-4-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-sm-4-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-4-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-4-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-4-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'column',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-4-49A5137K-4': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'OFF',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-4-49A5137K-5': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'ON',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-4-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-sm-4-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a camera preset from the list below.',
            'P_fontSize': '1rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
        },
        '12-sm-4-49A5137J-2': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '',
            'P_fontWeight': '',
            'P_iconName': 'camera',
            'P_iconSize': '1.6rem',
            'P_iconColor': 'white',
            'P_flexDirection': '',
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-4-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 71,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Presenter',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '71': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-4-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 72,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Audience Cameras',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '72': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-4-HAN66INF-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 73,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'All Room Cameras',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '73': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-4-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
      },
      'p_5': {
        'background_img': '/dynamic/images/b1/NU_GUI/NEU_Creston_Touchscreen_bg_sm.png',
        'logo': "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png",
        page_props: {
          'P_pageButtonId': '0',
          'P_isPageClickable': '0'
        },
        page_logic: {
          '30': [
            {event_type: 4, eval_text: "autoswitch-on", event_actions: 1}
          ]
        },
        '12-sm-5-49A5137L': {
          component_id: 'GShutdownButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 13,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          }
        },
        '12-sm-5-49A5137M': {
          component_id: 'GPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 14,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '14': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        },
        '12-sm-5-49A5137N': {
          component_id: 'GMicPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 31,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 32,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 33,
            'P_buttonThreeMakeSingleEvent': 'multiple'
          },
          logic: {
            '31': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '40': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-5-49A5137O': {
          component_id: 'GSoundPanel2',
          available_props: {
            'P_disabled': 0,
            'P_buttonOneId': 21,
            'P_buttonOneMakeSingleEvent': 'single',
            'P_buttonTwoId': 22,
            'P_buttonTwoMakeSingleEvent': 'multiple',
            'P_buttonThreeId': 23,
            'P_buttonThreeMakeSingleEvent': 'multiple',
            'P_text': "64%"
          },
          logic: {
            '21': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
            '20': [{event_type: 3, event_actions: 4, eval_text: " "}]
          }
        },
        '12-sm-5-49A5137K-1': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 11,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '/dynamic/images/b1/NU_GUI/laptop.png',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'column',
          },
          logic: {
            '11': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-5-49A5137K-4': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 17,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'OFF',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '17': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-5-49A5137K-5': {
          component_id: 'GButtonWithImage',
          available_props: {
            'P_buttonId': 16,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': 'ON',
            'P_buttonWidth': '',
            'P_buttonHeight': '48px',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': 'white',
            'P_fontSize': '.9rem',
            'P_fontWeight': 'bold',
            'P_imgSrc': '',
            'P_imgWidth': '',
            'P_imgHeight': '33px',
            'P_flexDirection': 'row',
          },
          logic: {
            '16': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-5-49A5137G-1': {
          component_id: 'GDateTime',
          available_props: {
            'P_format': "MMM DD YYYY hh:mm A",
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_disabled': 0
          },
        },
        '12-sm-5-49A5137B-1': {
          component_id: 'GText',
          available_props: {
            'P_text': 'Please select a camera layout from the list below.',
            'P_fontSize': '1rem',
            'P_fontWeight': 'normal',
            'P_fontColor': 'black',
          },
        },
        '12-sm-5-49A5137J-2': {
          component_id: 'GButtonWithIcon',
          available_props: {
          	'P_textPlacement': 'inner',
            'P_buttonId': 12,
            'P_makeSingleEvent': 'single',
            'P_disabled': 0,
            'P_buttonText': '',
            'P_buttonWidth': '',
            'P_buttonHeight': '',
            'P_buttonColor': 'black',
            'P_buttonPadding': '9px',
            'P_fontColor': '',
            'P_fontSize': '',
            'P_fontWeight': '',
            'P_iconName': 'camera',
            'P_iconSize': '1.6rem',
            'P_iconColor': 'white',
            'P_flexDirection': '',
          },
          logic: {
            '12': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-5-HAN66INF-1': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 41,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Active Speaker Single View',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
          logic: {
            '41': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ],
          }
        },
        '12-sm-5-HAN66INF-2': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 42,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'Split View - Lecturer and Audience',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
        },
        '12-sm-5-HAN66INF-3': {
          component_id: 'GButton',
          available_props: {
            'P_buttonId': 43,
            'P_makeSingleEvent': 'single',
            'P_buttonText': 'View Room 3 Cameras View',
            'P_fontColor': 'white',
            'P_fontSize': '1rem',
            'P_fontWeight': 'bold',
            'P_background': 'black',
            'P_padding': '5px',
            'P_disabled': 0,
          },
        },
        '12-sm-5-49A5156Q': {
          component_id: 'GCamPrivacyButton',
          available_props: {
            'P_disabled': 0,
            'P_buttonId': 15,
            'P_makeSingleEvent': 'single',
            'P_buttonText': ''
          },
          logic: {
            '15': [
              {event_type: 1, event_actions: 1}, 
              {event_type: 2, event_actions: 2}
            ]
          }
        }
      }
    }
  },
  layout_information: {
    'lg': {
      // page 1 control
      "p_1": {
        'page_uid': 'p_1',
        'page_name': 'control',
        'page_elements': [
          { 'x': 0, 'y': 31.5, 'w': 4, 'h': 5, 'i': 1, element_id: '12-lg-1-49A5137L' }, // Shutdown
          { 'x': 44, 'y': 31.5, 'w': 4, 'h': 5, 'i': 2, element_id: '12-lg-1-49A5137M' }, // GPrivacyButton
          { 'x': 22, 'y': 32, 'w': 14, 'h': 5, 'i': 3, element_id: '12-lg-1-49A5137N' }, // mic panel
          { 'x': 7, 'y': 32, 'w': 14, 'h': 5, 'i': 4, element_id: '12-lg-1-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 9, 'h': 4, 'i': 5, element_id: '12-lg-1-49A5137K-1' }, // presentation
          { 'x': 25, 'y': 14, 'w': 6, 'h': 7, 'i': 6, element_id: '12-lg-1-49A5137K-2' }, // Solstice Pod
          { 'x': 31, 'y': 14, 'w': 6, 'h': 7, 'i': 7, element_id: '12-lg-1-49A5137K-3' }, // Room PC
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 8, element_id: '12-lg-1-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 21, 'w': 9, 'h': 3, 'i': 9, element_id: '12-lg-1-49A5137A-1' }, // Cameras
          { 'x': 19, 'y': 14, 'w': 6, 'h': 7, 'i': 10, element_id: '12-lg-1-49A5137J-1' }, // Blank
          { 'x': 19, 'y': 11, 'w': 18, 'h': 2, 'i': 11, element_id: '12-lg-1-49A5137B-1' }, // GText
          { 'x': 39, 'y': 31.5, 'w': 4, 'h': 5, 'i': 12, element_id: '12-lg-1-49A5156Q' }, // GCamPrivacy
          { 'x': 0, 'y': 15, 'w': 9, 'h': 3, 'i': 13, element_id: '12-lg-1-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 18, 'w': 9, 'h': 3, 'i': 14, element_id: '12-lg-1-49A5137A-3' }, // AutoSwitch OFF
        ]
      },
      // page 2 camera
      "p_2": {
        'page_uid': 'p_2',
        'page_name': 'camera',
        'page_elements': [
          { 'x': 0, 'y': 31.5, 'w': 4, 'h': 5, 'i': 1, element_id: '12-lg-2-49A5137L' }, // Shutdown
          { 'x': 44, 'y': 31.5, 'w': 4, 'h': 5, 'i': 2, element_id: '12-lg-2-49A5137M' }, // GPrivacyButton
          { 'x': 22, 'y': 32, 'w': 14, 'h': 5, 'i': 3, element_id: '12-lg-2-49A5137N' }, // mic panel
          { 'x': 7, 'y': 32, 'w': 14, 'h': 5, 'i': 4, element_id: '12-lg-2-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 9, 'h': 4, 'i': 5, element_id: '12-lg-2-49A5137K-1' }, // Presentation
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 6, element_id: '12-lg-2-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 21, 'w': 9, 'h': 3, 'i': 7, element_id: '12-lg-2-49A5137A-1' }, // Cameras
          { 'x': 22, 'y': 7, 'w': 9, 'h': 12, 'i': 8, element_id: '12-lg-2-49A5137J-1' }, // camera control panel
          { 'x': 38.5, 'y': 8, 'w': 4, 'h': 5, 'i': 9, element_id: "12-lg-2-HAN66INF-1"}, // cam1
          { 'x': 36, 'y': 14, 'w': 4, 'h': 5, 'i': 10, element_id: "12-lg-2-HAN66INF-2"}, // cam2
          { 'x': 41, 'y': 14, 'w': 4, 'h': 5, 'i': 11, element_id: "12-lg-2-HAN66INF-3"}, // cam3
          { 'x': 15, 'y': 24, 'w': 6, 'h': 5, 'i': 12, element_id: "12-lg-2-HAN66INF-4"}, // Preeset 1
          { 'x': 23, 'y': 24, 'w': 6, 'h': 5, 'i': 13, element_id: "12-lg-2-HAN66INF-5"}, // Preeset 2
          { 'x': 30, 'y': 24, 'w': 6, 'h': 5, 'i': 14, element_id: "12-lg-2-HAN66INF-6"}, // Preeset 3
          { 'x': 37, 'y': 24, 'w': 6, 'h': 5, 'i': 15, element_id: "12-lg-2-HAN66INF-7"}, // Preeset 4
          { 'x': 11, 'y': 14, 'w': 7, 'h': 3, 'i': 16, element_id: "12-lg-2-CDAATOVJR-1"}, // zoom out
          { 'x': 11, 'y': 10, 'w': 7, 'h': 3, 'i': 17, element_id: "12-lg-2-CDAATOVJR-2"}, // zoom in
          { 'x': 39, 'y': 31.5, 'w': 4, 'h': 5, 'i': 18, element_id: '12-lg-2-49A5156Q' }, // GCamPrivacy
          { 'x': 0, 'y': 15, 'w': 9, 'h': 3, 'i': 19, element_id: '12-lg-2-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 18, 'w': 9, 'h': 3, 'i': 20, element_id: '12-lg-2-49A5137A-3' }, // AutoSwitch OFF
        ]
      },
      "p_3": {
        'page_uid': 'p_3',
        'page_name': 'intro',
        'page_elements': [
          { 'x': 13, 'y': 11, 'w': 24, 'h': 14, 'i': 1, element_id: '12-lg-3-49A5137D-1' },
          { 'x': 16, 'y': 30, 'w': 15, 'h': 3, 'i': 2, element_id: '12-lg-3-49A5137B-2' },
          { 'x': 12, 'y': 3, 'w': 24, 'h': 3, 'i': 3, element_id: '12-lg-3-49A5137P' },
        ]
      },
      "p_4": {
        'page_uid': 'p_4',
        'page_name': 'autoswitch-off',
        'page_elements': [
          { 'x': 0, 'y': 31.5, 'w': 4, 'h': 5, 'i': 1, element_id: '12-lg-4-49A5137L' }, // Shutdown
          { 'x': 44, 'y': 31.5, 'w': 4, 'h': 5, 'i': 2, element_id: '12-lg-4-49A5137M' }, // GPrivacyButton
          { 'x': 22, 'y': 32, 'w': 14, 'h': 5, 'i': 3, element_id: '12-lg-4-49A5137N' }, // mic panel
          { 'x': 7, 'y': 32, 'w': 14, 'h': 5, 'i': 4, element_id: '12-lg-4-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 9, 'h': 4, 'i': 5, element_id: '12-lg-4-49A5137K-1' }, // presentation
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 6, element_id: '12-lg-4-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 21, 'w': 9, 'h': 3, 'i': 7, element_id: '12-lg-4-49A5137A-1' }, // Cameras
          { 'x': 16, 'y': 9, 'w': 23, 'h': 2, 'i': 8, element_id: '12-lg-4-49A5137B-1' }, // GText
          { 'x': 0, 'y': 15, 'w': 9, 'h': 3, 'i': 9, element_id: '12-lg-4-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 18, 'w': 9, 'h': 3, 'i': 10, element_id: '12-lg-4-49A5137A-3' }, // AutoSwitch OFF
          { 'x': 11, 'y': 14, 'w': 9, 'h': 6, 'i': 11, element_id: "12-lg-4-HAN66INF-1"}, // Presentar
          { 'x': 23, 'y': 14, 'w': 10, 'h': 6, 'i': 12, element_id: "12-lg-4-HAN66INF-2"}, // Audience Cameras
          { 'x': 36, 'y': 14, 'w': 10, 'h': 6, 'i': 13, element_id: "12-lg-4-HAN66INF-3"}, // All Room Cameras
          { 'x': 39, 'y': 31.5, 'w': 4, 'h': 5, 'i': 14, element_id: "12-lg-4-49A5156Q"}, // Cam Privacy
        ]
      },
      "p_5": {
        'page_uid': 'p_5',
        'page_name': 'autoswitch-on',
        'page_elements': [
          { 'x': 0, 'y': 31.5, 'w': 4, 'h': 5, 'i': 1, element_id: '12-lg-5-49A5137L' }, // Shutdown
          { 'x': 44, 'y': 31.5, 'w': 4, 'h': 5, 'i': 2, element_id: '12-lg-5-49A5137M' }, // GPrivacyButton
          { 'x': 22, 'y': 32, 'w': 14, 'h': 5, 'i': 3, element_id: '12-lg-5-49A5137N' }, // mic panel
          { 'x': 7, 'y': 32, 'w': 14, 'h': 5, 'i': 4, element_id: '12-lg-5-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 9, 'h': 4, 'i': 5, element_id: '12-lg-5-49A5137K-1' }, // presentation
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 6, element_id: '12-lg-5-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 21, 'w': 9, 'h': 3, 'i': 7, element_id: '12-lg-5-49A5137A-1' }, // Cameras
          { 'x': 16, 'y': 9, 'w': 23, 'h': 2, 'i': 8, element_id: '12-lg-5-49A5137B-1' }, // GText
          { 'x': 0, 'y': 15, 'w': 9, 'h': 3, 'i': 9, element_id: '12-lg-5-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 18, 'w': 9, 'h': 3, 'i': 10, element_id: '12-lg-5-49A5137A-3' }, // AutoSwitch OFF
          { 'x': 11, 'y': 14, 'w': 9, 'h': 6, 'i': 11, element_id: "12-lg-5-HAN66INF-1"}, // Presentar
          { 'x': 23, 'y': 14, 'w': 10, 'h': 6, 'i': 12, element_id: "12-lg-5-HAN66INF-2"}, // Audience Cameras
          { 'x': 36, 'y': 14, 'w': 10, 'h': 6, 'i': 13, element_id: "12-lg-5-HAN66INF-3"}, // All Room Cameras
          { 'x': 11, 'y': 20, 'w': 9, 'h': 3, 'i': 14, element_id: '12-lg-5-49A5137B-2' }, // Presentar Text
          { 'x': 23, 'y': 20, 'w': 10, 'h': 3, 'i': 15, element_id: '12-lg-5-49A5137B-3' }, // Audience Cameras Text
          { 'x': 37, 'y': 20, 'w': 8, 'h': 6, 'i': 16, element_id: '12-lg-5-49A5137B-4' }, // All Room Cameras Text
          { 'x': 39, 'y': 31.5, 'w': 4, 'h': 5, 'i': 17, element_id: "12-lg-5-49A5156Q"}, // Cam Privacy
        ]
      },
    },
    'md': {
      // page 1 control
      "p_1": {
        'page_uid': 'p_1',
        'page_name': 'control',
        'page_elements': [
          { 'x': 0, 'y': 32, 'w': 5, 'h': 5, 'i': 1, element_id: '12-md-1-49A5137L' }, // Shutdown
          { 'x': 42, 'y': 32, 'w': 5, 'h': 5, 'i': 2, element_id: '12-md-1-49A5137M' }, // GPrivacyButton
          { 'x': 21, 'y': 31.5, 'w': 15, 'h': 5, 'i': 3, element_id: '12-md-1-49A5137N' }, // mic panel
          { 'x': 5, 'y': 31.5, 'w': 15, 'h': 5, 'i': 4, element_id: '12-md-1-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 12, 'h': 4, 'i': 5, element_id: '12-md-1-49A5137K-1' }, // presentation
          { 'x': 27, 'y': 14, 'w': 8, 'h': 7, 'i': 6, element_id: '12-md-1-49A5137K-2' }, // Solstice Pod
          { 'x': 35, 'y': 14, 'w': 8, 'h': 7, 'i': 7, element_id: '12-md-1-49A5137K-3' }, // Room PC
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 8, element_id: '12-md-1-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 19, 'w': 12, 'h': 3, 'i': 9, element_id: '12-md-1-49A5137A-1' }, // Cameras
          { 'x': 19, 'y': 14, 'w': 8, 'h': 7, 'i': 10, element_id: '12-md-1-49A5137J-1' }, // Blank
          { 'x': 16, 'y': 12, 'w': 21, 'h': 2, 'i': 11, element_id: '12-md-1-49A5137B-1' }, // GText
          { 'x': 37, 'y': 32, 'w': 5, 'h': 5, 'i': 12, element_id: '12-md-1-49A5156Q' }, // GCamPrivacy
          { 'x': 0, 'y': 15, 'w': 12, 'h': 3, 'i': 13, element_id: '12-md-1-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 17, 'w': 12, 'h': 3, 'i': 14, element_id: '12-md-1-49A5137A-3' } // AutoSwitch OFF
        ]
      },
      // page 2 camera
      'p_2': {
        'page_uid': 'p_2',
        'page_name': 'camera',
        'page_elements': [
          { 'x': 0, 'y': 32, 'w': 5, 'h': 5, 'i': 1, element_id: '12-md-2-49A5137L' }, // Shutdown
          { 'x': 42, 'y': 32, 'w': 5, 'h': 5, 'i': 2, element_id: '12-md-2-49A5137M' }, // GPrivacyButton
          { 'x': 21, 'y': 31.5, 'w': 15, 'h': 5, 'i': 3, element_id: '12-md-2-49A5137N' }, // mic panel
          { 'x': 5, 'y': 31.5, 'w': 15, 'h': 5, 'i': 4, element_id: '12-md-2-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 12, 'h': 4, 'i': 5, element_id: '12-md-2-49A5137K-1' }, // Presentation
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 6, element_id: '12-md-2-49A5137G-1' }, // date
          { 'x': 0, 'y': 19, 'w': 12, 'h': 3, 'i': 7, element_id: '12-md-2-49A5137A-1' }, // cameras 
          { 'x': 22, 'y': 8, 'w': 12, 'h': 12, 'i': 8, element_id: '12-md-2-49A5137J-1' }, // camera control panel
          { 'x': 40, 'y': 9, 'w': 4, 'h': 4, 'i': 9, element_id: "12-md-2-HAN66INF-1"}, // cam1
          { 'x': 38, 'y': 14, 'w': 4, 'h': 4, 'i': 10, element_id: "12-md-2-HAN66INF-2"}, // cam2
          { 'x': 43, 'y': 14, 'w': 4, 'h': 4, 'i': 11, element_id: "12-md-2-HAN66INF-3"}, // cam3
          { 'x': 18, 'y': 24, 'w': 6, 'h': 5, 'i': 12, element_id: "12-md-2-HAN66INF-4"}, // Preeset 1
          { 'x': 25, 'y': 24, 'w': 6, 'h': 5, 'i': 13, element_id: "12-md-2-HAN66INF-5"}, // Preeset 2
          { 'x': 32, 'y': 24, 'w': 6, 'h': 5, 'i': 14, element_id: "12-md-2-HAN66INF-6"}, // Preeset 3
          { 'x': 38, 'y': 24, 'w': 6, 'h': 5, 'i': 15, element_id: "12-md-2-HAN66INF-7"}, // Preeset 4
          { 'x': 13, 'y': 17, 'w': 7, 'h': 3, 'i': 16, element_id: "12-md-2-CDAATOVJR-1"}, // zoom out
          { 'x': 13, 'y': 12, 'w': 7, 'h': 3, 'i': 17, element_id: "12-md-2-CDAATOVJR-2"}, // zoom in
          { 'x': 37, 'y': 32, 'w': 5, 'h': 5, 'i': 18, element_id: '12-md-2-49A5156Q' }, // GCamPrivacy
          { 'x': 0, 'y': 15, 'w': 12, 'h': 3, 'i': 19, element_id: '12-md-2-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 17, 'w': 12, 'h': 3, 'i': 20, element_id: '12-md-2-49A5137A-3' }, // AutoSwitch OFF
        ]
      },
      "p_3": {
        'page_uid': 'p_3',
        'page_name': 'intro',
        'page_elements': [
          { 'x': 11, 'y': 11, 'w': 24, 'h': 14, 'i': 1, element_id: '12-md-3-49A5137D-1' },
          { 'x': 8, 'y': 31, 'w': 30, 'h': 3, 'i': 2, element_id: '12-md-3-49A5137B-2' },
          { 'x': 9, 'y': 3, 'w': 28, 'h': 3, 'i': 3, element_id: '12-md-3-49A5137P-3' },
        ]
      },
      "p_4": {
        'page_uid': 'p_4',
        'page_name': 'autoswitch-off',
        'page_elements': [
          { 'x': 0, 'y': 32, 'w': 5, 'h': 5, 'i': 1, element_id: '12-md-4-49A5137L' }, // Shutdown
          { 'x': 42, 'y': 32, 'w': 5, 'h': 5, 'i': 2, element_id: '12-md-4-49A5137M' }, // GPrivacyButton
          { 'x': 21, 'y': 31.5, 'w': 15, 'h': 5, 'i': 3, element_id: '12-md-4-49A5137N' }, // mic panel
          { 'x': 5, 'y': 31.5, 'w': 15, 'h': 5, 'i': 4, element_id: '12-md-4-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 12, 'h': 4, 'i': 5, element_id: '12-md-4-49A5137K-1' }, // presentation
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 6, element_id: '12-md-4-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 19, 'w': 12, 'h': 3, 'i': 7, element_id: '12-md-4-49A5137A-1' }, // Cameras
          { 'x': 15, 'y': 10, 'w': 29, 'h': 2, 'i': 8, element_id: '12-md-4-49A5137B-1' }, // GText
          { 'x': 0, 'y': 15, 'w': 12, 'h': 3, 'i': 9, element_id: '12-md-4-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 17, 'w': 12, 'h': 3, 'i': 10, element_id: '12-md-4-49A5137A-3' }, // AutoSwitch OFF
          { 'x': 14, 'y': 15, 'w': 9, 'h': 5, 'i': 11, element_id: "12-md-4-HAN66INF-1"}, // Presentar
          { 'x': 25, 'y': 15, 'w': 9, 'h': 5, 'i': 12, element_id: "12-md-4-HAN66INF-2"}, // Audience Cameras
          { 'x': 36, 'y': 15, 'w': 9, 'h': 5, 'i': 13, element_id: "12-md-4-HAN66INF-3"}, // All Room Cameras
          { 'x': 37, 'y': 32, 'w': 5, 'h': 5, 'i': 14, element_id: '12-md-4-49A5156Q' }, // GCamPrivacy
        ]
      },
      "p_5": {
        'page_uid': 'p_5',
        'page_name': 'autoswitch-on',
        'page_elements': [
          { 'x': 0, 'y': 32, 'w': 5, 'h': 5, 'i': 1, element_id: '12-md-5-49A5137L' }, // Shutdown
          { 'x': 42, 'y': 32, 'w': 5, 'h': 5, 'i': 2, element_id: '12-md-5-49A5137M' }, // GPrivacyButton
          { 'x': 21, 'y': 31.5, 'w': 15, 'h': 5, 'i': 3, element_id: '12-md-5-49A5137N' }, // mic panel
          { 'x': 5, 'y': 31.5, 'w': 15, 'h': 5, 'i': 4, element_id: '12-md-5-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 12, 'h': 4, 'i': 5, element_id: '12-md-5-49A5137K-1' }, // presentation
          { 'x': 40, 'y': 0, 'w': 8, 'h': 2, 'i': 6, element_id: '12-md-5-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 19, 'w': 12, 'h': 3, 'i': 7, element_id: '12-md-5-49A5137A-1' }, // Cameras
          { 'x': 15, 'y': 10, 'w': 29, 'h': 2, 'i': 8, element_id: '12-md-5-49A5137B-1' }, // GText
          { 'x': 0, 'y': 15, 'w': 12, 'h': 3, 'i': 9, element_id: '12-md-5-49A5137A-2' }, // AutoSwitch ON
          { 'x': 0, 'y': 17, 'w': 12, 'h': 3, 'i': 10, element_id: '12-md-5-49A5137A-3' }, // AutoSwitch OFF
          { 'x': 14, 'y': 15, 'w': 9, 'h': 5, 'i': 11, element_id: "12-md-5-HAN66INF-1"}, // Presentar
          { 'x': 25, 'y': 15, 'w': 9, 'h': 5, 'i': 12, element_id: "12-md-5-HAN66INF-2"}, // Audience Cameras
          { 'x': 36, 'y': 15, 'w': 9, 'h': 5, 'i': 13, element_id: "12-md-5-HAN66INF-3"}, // All Room Cameras
          { 'x': 14, 'y': 20, 'w': 9, 'h': 3, 'i': 14, element_id: '12-md-5-49A5137B-2' }, // Presentar Text
          { 'x': 25, 'y': 20, 'w': 10, 'h': 3, 'i': 15, element_id: '12-md-5-49A5137B-3' }, // Audience Cameras Text
          { 'x': 37, 'y': 20, 'w': 8, 'h': 6, 'i': 16, element_id: '12-md-5-49A5137B-4' }, // All Room Cameras Text
          { 'x': 37, 'y': 32, 'w': 5, 'h': 5, 'i': 17, element_id: '12-md-5-49A5156Q' }, // GCamPrivacy
        ]
      },
    },
    'sm': {
      // page 1 control
      'p_1': {
        'page_uid': 'p_1',
        'page_name': 'control',
        'page_elements': [
          { 'x': 8, 'y': 16, 'w': 9, 'h': 4, 'i': 1, element_id: '12-sm-1-49A5137L' }, // Shutdown
          { 'x': 37, 'y': 16, 'w': 9, 'h': 4, 'i': 2, element_id: '12-sm-1-49A5137M' }, // GPrivacyButton
          { 'x': 0, 'y': 26, 'w': 45, 'h': 5, 'i': 3, element_id: '12-sm-1-49A5137N' }, // mic panel
          { 'x': 0, 'y': 20, 'w': 45, 'h': 5, 'i': 4, element_id: '12-sm-1-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 7, 'h': 3, 'i': 5, element_id: '12-sm-1-49A5137K-1' }, // presentation
          { 'x': 11, 'y': 10, 'w': 30, 'h': 3, 'i': 6, element_id: '12-sm-1-49A5137K-2' }, // Solstice Pod
          { 'x': 11, 'y': 7, 'w': 30, 'h': 3, 'i': 7, element_id: '12-sm-1-49A5137K-3' }, // Room PC
          { 'x': 32, 'y': 1, 'w': 16, 'h': 2, 'i': 8, element_id: '12-sm-1-49A5137G-1' }, // GDateTime
          { 'x': 11, 'y': 13, 'w': 30, 'h': 3, 'i': 9, element_id: '12-sm-1-49A5137J-1' }, // Blank
          { 'x': 0, 'y': 9, 'w': 7, 'h': 3, 'i': 10, element_id: '12-sm-1-49A5137J-2' }, // Camera
          { 'x': 10, 'y': 4, 'w': 30, 'h': 3, 'i': 11, element_id: '12-sm-1-49A5137B-1' }, // GText
          { 'x': 22, 'y': 16, 'w': 9, 'h': 4, 'i': 12, element_id: '12-sm-1-49A5156Q' }, // GCamPrivacy
          { 'x': 0, 'y': 8, 'w': 7, 'h': 3, 'i': 13, element_id: '12-sm-1-49A5137K-4' }, // AutoSwitch OFF
          { 'x': 0, 'y': 7, 'w': 7, 'h': 3, 'i': 14, element_id: '12-sm-1-49A5137K-5' }, // AutoSwitch ON
        ]
      },
      // page 2 camera
      'p_2': {
        'page_uid': 'p_2',
        'page_name': 'camera',
        'page_elements': [
          { 'x': 8, 'y': 16, 'w': 9, 'h': 4, 'i': 1, element_id: '12-sm-2-49A5137L' }, // shutdown
          { 'x': 38, 'y': 16, 'w': 9, 'h': 4, 'i': 2, element_id: '12-sm-2-49A5137M' }, // privacy button
          { 'x': 0, 'y': 26, 'w': 45, 'h': 5, 'i': 3, element_id: '12-sm-2-49A5137N' }, // mic panel
          { 'x': 0, 'y': 20, 'w': 45, 'h': 5, 'i': 4, element_id: '12-sm-2-49A5137O' }, // sound panel
          { 'x': 0, 'y': 4, 'w': 7, 'h': 3, 'i': 5, element_id: '12-sm-2-49A5137K-1' }, // presentation button
          { 'x': 32, 'y': 1, 'w': 16, 'h': 2, 'i': 6, element_id: '12-sm-2-49A5137G-1' }, // date
          { 'x': 0, 'y': 9, 'w': 7, 'h': 3, 'i': 7, element_id: '12-sm-2-49A5137J-6' }, // camera
          { 'x': 20, 'y': 5, 'w': 16, 'h': 7, 'i': 8, element_id: '12-sm-2-49A5137J-1' }, // camera control panel
          { 'x': 40, 'y': 4, 'w': 8, 'h': 3, 'i': 9, element_id: "12-sm-2-HAN66INF-1"}, // cam1
          { 'x': 40, 'y': 7, 'w': 8, 'h': 3, 'i': 10, element_id: "12-sm-2-HAN66INF-2"}, // cam2
          { 'x': 40, 'y': 10, 'w': 8, 'h': 3, 'i': 11, element_id: "12-sm-2-HAN66INF-3"}, // cam3
          { 'x': 8, 'y': 14, 'w': 10, 'h': 2, 'i': 12, element_id: "12-sm-2-HAN66INF-4"}, // Preeset 1
          { 'x': 18, 'y': 14, 'w': 10, 'h': 2, 'i': 13, element_id: "12-sm-2-HAN66INF-5"}, // Preeset 2
          { 'x': 28, 'y': 14, 'w': 10, 'h': 2, 'i': 14, element_id: "12-sm-2-HAN66INF-6"}, // Preeset 3
          { 'x': 38, 'y': 14, 'w': 10, 'h': 2, 'i': 15, element_id: "12-sm-2-HAN66INF-7"}, // Preeset 4
          { 'x': 8, 'y': 5, 'w': 9, 'h': 4, 'i': 16, element_id: "12-sm-2-CDAATOVJR-1"}, // zoom out
          { 'x': 8, 'y': 9, 'w': 9, 'h': 4, 'i': 17, element_id: "12-sm-2-CDAATOVJR-2"}, // zoom in
          { 'x': 22, 'y': 16, 'w': 9, 'h': 4, 'i': 18, element_id: '12-sm-2-49A5156Q' }, // GCamPrivacy
          { 'x': 0, 'y': 8, 'w': 7, 'h': 3, 'i': 19, element_id: '12-sm-2-49A5137K-2' }, // AutoSwitch OFF
          { 'x': 0, 'y': 7, 'w': 7, 'h': 3, 'i': 20, element_id: '12-sm-2-49A5137K-3' }, // AutoSwitch ON
        ]
      },
      'p_3': {
        'page_uid': 'p_3',
        'page_name': 'intro',
        'page_elements': [
          { 'x': 1, 'y': 11, 'w': 45, 'h': 10, 'i': 1, element_id: '12-sm-3-49A5137D-1' },
          { 'x': 8, 'y': 26, 'w': 30, 'h': 2, 'i': 2, element_id: '12-sm-3-49A5137B-2' },
          { 'x': 5, 'y': 5, 'w': 38, 'h': 3, 'i': 3, element_id: '12-sm-3-49A5137P-3' },
        ]
      },
      'p_4': {
        'page_uid': 'p_4',
        'page_name': 'autoswitch-off',
        'page_elements': [
          { 'x': 8, 'y': 16, 'w': 9, 'h': 4, 'i': 1, element_id: '12-sm-4-49A5137L' }, // shutdown
          { 'x': 38, 'y': 16, 'w': 9, 'h': 4, 'i': 2, element_id: '12-sm-4-49A5137M' }, // privacy button
          { 'x': 0, 'y': 26, 'w': 45, 'h': 5, 'i': 3, element_id: '12-sm-4-49A5137N' }, // mic panel
          { 'x': 0, 'y': 20, 'w': 45, 'h': 5, 'i': 4, element_id: '12-sm-4-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 7, 'h': 3, 'i': 5, element_id: '12-sm-4-49A5137K-1' }, // presentation
          { 'x': 32, 'y': 1, 'w': 16, 'h': 2, 'i': 6, element_id: '12-sm-4-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 9, 'w': 7, 'h': 3, 'i': 7, element_id: '12-sm-4-49A5137J-2' }, // Camera
          { 'x': 10, 'y': 4, 'w': 30, 'h': 3, 'i': 8, element_id: '12-sm-4-49A5137B-1' }, // GText
          { 'x': 0, 'y': 8, 'w': 7, 'h': 3, 'i': 9, element_id: '12-sm-4-49A5137K-4' }, // AutoSwitch Off
          { 'x': 0, 'y': 7, 'w': 7, 'h': 3, 'i': 10, element_id: '12-sm-4-49A5137K-5' }, // AutoSwitch On
          { 'x': 12, 'y': 7, 'w': 30, 'h': 3, 'i': 11, element_id: "12-sm-4-HAN66INF-1"}, // Presenter
          { 'x': 12, 'y': 10, 'w': 30, 'h': 3, 'i': 12, element_id: "12-sm-4-HAN66INF-2"}, // Audience Cameras
          { 'x': 12, 'y': 13, 'w': 30, 'h': 3, 'i': 13, element_id: "12-sm-4-HAN66INF-3"}, // All Room Cameras
          { 'x': 22, 'y': 16, 'w': 9, 'h': 4, 'i': 14, element_id: '12-sm-4-49A5156Q' }, // GCamPrivacy
        ]
      },
       'p_5': {
        'page_uid': 'p_5',
        'page_name': 'autoswitch-on',
        'page_elements': [
          { 'x': 8, 'y': 16, 'w': 9, 'h': 4, 'i': 1, element_id: '12-sm-5-49A5137L' }, // shutdown
          { 'x': 38, 'y': 16, 'w': 9, 'h': 4, 'i': 2, element_id: '12-sm-5-49A5137M' }, // privacy button
          { 'x': 0, 'y': 26, 'w': 45, 'h': 5, 'i': 3, element_id: '12-sm-5-49A5137N' }, // mic panel
          { 'x': 0, 'y': 20, 'w': 45, 'h': 5, 'i': 4, element_id: '12-sm-5-49A5137O' }, // sound panel 
          { 'x': 0, 'y': 4, 'w': 7, 'h': 3, 'i': 5, element_id: '12-sm-5-49A5137K-1' }, // presentation
          { 'x': 32, 'y': 1, 'w': 16, 'h': 2, 'i': 6, element_id: '12-sm-5-49A5137G-1' }, // GDateTime
          { 'x': 0, 'y': 9, 'w': 7, 'h': 3, 'i': 7, element_id: '12-sm-5-49A5137J-2' }, // Camera
          { 'x': 10, 'y': 4, 'w': 30, 'h': 3, 'i': 8, element_id: '12-sm-5-49A5137B-1' }, // GText
          { 'x': 0, 'y': 8, 'w': 7, 'h': 3, 'i': 9, element_id: '12-sm-5-49A5137K-4' }, // AutoSwitch Off
          { 'x': 0, 'y': 7, 'w': 7, 'h': 3, 'i': 10, element_id: '12-sm-5-49A5137K-5' }, // AutoSwitch On
          { 'x': 12, 'y': 7, 'w': 30, 'h': 3, 'i': 11, element_id: "12-sm-5-HAN66INF-1"}, // Presenter
          { 'x': 12, 'y': 10, 'w': 30, 'h': 3, 'i': 12, element_id: "12-sm-5-HAN66INF-2"}, // Audience Cameras
          { 'x': 12, 'y': 13, 'w': 30, 'h': 3, 'i': 13, element_id: "12-sm-5-HAN66INF-3"}, // All Room Cameras
          { 'x': 22, 'y': 16, 'w': 9, 'h': 4, 'i': 14, element_id: '12-sm-5-49A5156Q' }, // GCamPrivacy
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/watchdog_includes/sample_Crestron_GUI_Layout.js